import getAuthorLink from '../../../../../../utils/url/get-author-link';
import DomainSensitiveLink from '../../../../../domain-sensitive-link/domain-sensitive-link';
import './material-owner.scss';

type MaterialOwnerProps = { item: Material; disableLink?: boolean };

const MaterialOwner = (props: MaterialOwnerProps) => {
    const { item, disableLink } = props;

    const { author } = item;

    const wrapperClassNames = 'd-flex align-items-center material-owner tsc-body-highlighted';

    if (disableLink) {
        return (
            <div className={wrapperClassNames}>
                <span className='tsc-caption material-owner-name ellipsis no-link'>{author?.details?.publicName}</span>
            </div>
        );
    }

    return (
        <div className={wrapperClassNames}>
            <DomainSensitiveLink className='tsc-caption material-owner-name ellipsis' href={getAuthorLink(author)}>
                {author?.details?.publicName}
            </DomainSensitiveLink>
        </div>
    );
};

export default MaterialOwner;
